module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "admin"
  }, [_c('h1', [_vm._v(_vm._s(_vm.getAppName()))]), _vm._v(" "), _c('md-bottom-bar', [_c('md-bottom-bar-item', {
    attrs: {
      "md-icon": "announcement",
      "md-active": _vm.ifRoute('admin-notifications')
    },
    nativeOn: {
      "click": function($event) {
        _vm.goToRoute('admin-notifications')
      }
    }
  }, [_vm._v("Értesítések")]), _vm._v(" "), _c('md-bottom-bar-item', {
    attrs: {
      "md-icon": "speaker_notes",
      "md-active": _vm.ifRoute('admin-answers')
    },
    nativeOn: {
      "click": function($event) {
        _vm.goToRoute('admin-answers')
      }
    }
  }, [_vm._v("Válaszok")]), _vm._v(" "), _c('md-bottom-bar-item', {
    attrs: {
      "md-icon": "event",
      "md-active": _vm.ifRoute('admin-presentations')
    },
    nativeOn: {
      "click": function($event) {
        _vm.goToRoute('admin-presentations')
      }
    }
  }, [_vm._v("Napirend")]), _vm._v(" "), _c('md-bottom-bar-item', {
    attrs: {
      "md-icon": "face",
      "md-active": _vm.ifRoute('admin-lecturers')
    },
    nativeOn: {
      "click": function($event) {
        _vm.goToRoute('admin-lecturers')
      }
    }
  }, [_vm._v("Előadók")]), _vm._v(" "), _c('md-bottom-bar-item', {
    attrs: {
      "md-icon": "info_outline",
      "md-active": _vm.ifRoute('admin-information')
    },
    nativeOn: {
      "click": function($event) {
        _vm.goToRoute('admin-information')
      }
    }
  }, [_vm._v("Információk")]), _vm._v(" "), _c('md-bottom-bar-item', {
    attrs: {
      "md-icon": "cancel"
    },
    nativeOn: {
      "click": function($event) {
        _vm.logout()
      }
    }
  }, [_vm._v("Kijelentkezés")])], 1), _vm._v(" "), _c('router-view')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-8df93e2c!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Admin/AdminView.vue
// module id = 557
// module chunks = 2